<template>
  <div>
    <v-container fluid>
      <Manpowermenubar_govem />
      <base-material-card
        icon="mdi-clipboard-account"
        title="แบบรายงานผลการประเมินการปฏิบัติงาน พนักงานราชการส่วนกลาง (แบบ ปผ.พนร.)"
        class="px-5 py-3"
      >
        <!-- ===== Header Info ===== -->
        <v-alert
          type="info"
          prominent
          outlined
          border="left"
          colored-border
          elevation="2"
          icon="mdi-domain"
          class="mb-4"
        >
          <div class="text-subtitle-1 font-weight-medium">
            แบบรายงานผลการประเมินการปฏิบัติงาน
            และรายงานข้อมูลการลา/มาสาย/ขาดราชการ (แบบ ปผ.พนร.) —
            <strong>ระดับส่วนกลาง</strong>
          </div>
          <div class="text-body-2 mt-1">
            ปีงบประมาณ พ.ศ. {{ selectedYear }} | พนักงานราชการส่วนกลางทั้งหมด
            <strong>{{ personnelList.length }}</strong> คน จาก
            <strong>{{ collegeList.length }}</strong> หน่วยงาน
          </div>
          <div class="text-caption mt-1">
            <strong>รอบที่ 1:</strong> 1 ต.ค. {{ selectedYear - 1 }} – 31 มี.ค.
            {{ selectedYear }} &nbsp;|&nbsp; <strong>รอบที่ 2:</strong> 1 เม.ย.
            {{ selectedYear }} – 30 ก.ย. {{ selectedYear }}
          </div>
          <div class="text-caption mt-1 grey--text">
            <v-icon x-small>mdi-scale-balance</v-icon>
            เกณฑ์: ดีเด่น 95-100 | ดีมาก 85-94 | ดี 75-84 | พอใช้ 65-74 |
            ต้องปรับปรุง &lt;65
          </div>
        </v-alert>

        <!-- ===== Summary Cards ===== -->
        <v-row class="mb-4">
          <v-col
            cols="6"
            sm="4"
            md="2"
            v-for="card in summaryCards"
            :key="card.label"
          >
            <v-card outlined class="text-center pa-3 rounded-lg">
              <v-icon :color="card.color" class="mb-1">{{ card.icon }}</v-icon>
              <div :class="`text-h5 font-weight-bold ${card.color}--text`">
                {{ card.value }}
              </div>
              <div class="text-caption grey--text">{{ card.label }}</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- ===== Progress Bar รายงานความครบถ้วน ===== -->
        <v-card outlined class="mb-4 pa-3">
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="text-subtitle-2 font-weight-bold">
              <v-icon small color="primary" class="mr-1"
                >mdi-progress-check</v-icon
              >
              ความครบถ้วนของการรายงาน ปี {{ selectedYear }}
            </span>
            <span class="text-caption grey--text">
              รอบ 1: {{ summaryStats.submitted_round1 }}/{{
                personnelList.length
              }}
              คน &nbsp;|&nbsp; รอบ 2: {{ summaryStats.submitted_round2 }}/{{
                personnelList.length
              }}
              คน
            </span>
          </div>
          <div class="text-caption mb-1 blue--text">รอบที่ 1</div>
          <v-progress-linear
            :value="round1Progress"
            color="blue"
            background-color="blue lighten-4"
            height="18"
            rounded
          >
            <span class="white--text text-caption font-weight-bold"
              >{{ round1Progress }}%</span
            >
          </v-progress-linear>
          <div class="text-caption mt-2 mb-1 teal--text">รอบที่ 2</div>
          <v-progress-linear
            :value="round2Progress"
            color="teal"
            background-color="teal lighten-4"
            height="18"
            rounded
          >
            <span class="white--text text-caption font-weight-bold"
              >{{ round2Progress }}%</span
            >
          </v-progress-linear>
        </v-card>

        <!-- ===== Filters ===== -->
        <v-row class="mb-3" dense>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="selectedYear"
              :items="years"
              label="ปีงบประมาณ"
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
              @change="loadAllData"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="selectedCollegeCode"
              :items="collegeFilterOptions"
              item-text="text"
              item-value="value"
              label="กรองตามหน่วยงาน"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-domain"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="statusFilter"
              :items="statusFilterOptions"
              label="กรองตามสถานะ"
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-filter"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
            class="d-flex align-center"
            style="gap:8px"
          >
            <v-text-field
              v-model="searchText"
              placeholder="ค้นหาชื่อ..."
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex flex-wrap" style="gap:8px">
            <v-btn
              color="primary"
              small
              @click="loadAllData"
              :loading="loading"
            >
              <v-icon left small>mdi-refresh</v-icon>โหลดใหม่
            </v-btn>
            <v-btn
              color="success"
              small
              @click="generateReport"
              :disabled="personnelList.length === 0"
            >
              <v-icon left small>mdi-chart-line</v-icon>สร้างรายงานสรุป
            </v-btn>
            <v-btn
              color="info"
              small
              @click="exportToExcel"
              :disabled="mergedPersonnelData.length === 0"
            >
              <v-icon left small>mdi-file-excel</v-icon>ส่งออก Excel (ปผ.พนร.)
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="viewMode" mandatory dense color="primary">
              <v-btn small value="list"
                ><v-icon small>mdi-view-list</v-icon></v-btn
              >
              <v-btn small value="card"
                ><v-icon small>mdi-view-grid</v-icon></v-btn
              >
            </v-btn-toggle>
          </v-col>
        </v-row>

        <!-- ===== Main Table: รายชื่อพนักงาน + สถานะ ===== -->
        <template v-if="viewMode === 'list'">
          <v-data-table
            :headers="personnelHeaders"
            :items="filteredPersonnelData"
            :loading="loading"
            :items-per-page="20"
            class="elevation-1 personnel-table"
            :search="searchText"
          >
            <!-- ลำดับ -->
            <template v-slot:item.seq="{ item }">
              <span class="grey--text">{{
                filteredPersonnelData.indexOf(item) + 1
              }}</span>
            </template>

            <!-- หน่วยงาน -->
            <template v-slot:item.user_firstname="{ item }">
              <v-chip
                x-small
                color="primary lighten-4"
                class="primary--text text--darken-2"
                style="max-width:140px"
              >
                <span class="text-truncate" :title="item.user_firstname">{{
                  item.user_firstname || item.college_code
                }}</span>
              </v-chip>
            </template>

            <!-- ชื่อ-สกุล -->
            <template v-slot:item.full_name="{ item }">
              <div class="d-flex align-center">
                <v-avatar
                  size="28"
                  :color="
                    item.sex === 'หญิง' ? 'pink lighten-3' : 'blue lighten-3'
                  "
                  class="mr-2"
                >
                  <span class="text-caption white--text">{{
                    (item.frist_name || "?").charAt(0)
                  }}</span>
                </v-avatar>
                <div>
                  <div class="text-body-2 font-weight-medium">
                    {{ item.full_name }}
                  </div>
                  <div class="text-caption grey--text">
                    {{ item.name_postion }}
                  </div>
                </div>
              </div>
            </template>

            <!-- รอบ 1 -->
            <template v-slot:item.round1_status="{ item }">
              <div class="d-flex align-center" style="gap:4px">
                <template v-if="item.round1">
                  <v-chip
                    small
                    :color="getStatusColor(item.round1.assessment_status)"
                    text-color="white"
                    style="cursor:pointer"
                    @click="openAssessmentDialog(item, 1)"
                  >
                    <v-icon left x-small>mdi-check</v-icon>
                    {{ formatNumber(item.round1.total_score) }}
                    <span class="ml-1 text-caption"
                      >({{
                        getStatusLabel(item.round1.assessment_status)
                      }})</span
                    >
                  </v-chip>
                </template>
                <template v-else>
                  <v-btn
                    x-small
                    color="red lighten-1"
                    dark
                    @click="openAssessmentDialog(item, 1)"
                  >
                    <v-icon left x-small>mdi-plus</v-icon>กรอกรอบ 1
                  </v-btn>
                </template>
              </div>
            </template>

            <!-- รอบ 2 -->
            <template v-slot:item.round2_status="{ item }">
              <div class="d-flex align-center" style="gap:4px">
                <template v-if="item.round2">
                  <v-chip
                    small
                    :color="getStatusColor(item.round2.assessment_status)"
                    text-color="white"
                    style="cursor:pointer"
                    @click="openAssessmentDialog(item, 2)"
                  >
                    <v-icon left x-small>mdi-check</v-icon>
                    {{ formatNumber(item.round2.total_score) }}
                    <span class="ml-1 text-caption"
                      >({{
                        getStatusLabel(item.round2.assessment_status)
                      }})</span
                    >
                  </v-chip>
                </template>
                <template v-else>
                  <v-btn
                    x-small
                    color="red lighten-1"
                    dark
                    @click="openAssessmentDialog(item, 2)"
                  >
                    <v-icon left x-small>mdi-plus</v-icon>กรอกรอบ 2
                  </v-btn>
                </template>
              </div>
            </template>

            <!-- ข้อมูลการลา -->
            <template v-slot:item.attendance_status="{ item }">
              <template v-if="item.attendance">
                <v-chip
                  small
                  color="green"
                  text-color="white"
                  style="cursor:pointer"
                  @click="openAttendanceDialog(item)"
                >
                  <v-icon left x-small>mdi-calendar-check</v-icon>บันทึกแล้ว
                </v-chip>
              </template>
              <template v-else>
                <v-btn
                  x-small
                  color="orange"
                  dark
                  @click="openAttendanceDialog(item)"
                >
                  <v-icon left x-small>mdi-plus</v-icon>กรอกการลา
                </v-btn>
              </template>
            </template>

            <!-- วินัย -->
            <template v-slot:item.discipline_status="{ item }">
              <template v-if="item.disciplines && item.disciplines.length > 0">
                <v-chip
                  small
                  color="red darken-1"
                  text-color="white"
                  style="cursor:pointer"
                  @click="openDisciplineListDialog(item)"
                >
                  <v-icon left x-small>mdi-gavel</v-icon
                  >{{ item.disciplines.length }} รายการ
                </v-chip>
              </template>
              <template v-else>
                <v-btn
                  x-small
                  text
                  color="grey"
                  @click="openDisciplineDialog(item)"
                >
                  <v-icon left x-small>mdi-plus</v-icon>เพิ่ม
                </v-btn>
              </template>
            </template>

            <!-- สถานะรวม -->
            <template v-slot:item.overall_status="{ item }">
              <v-icon
                :color="getOverallStatusColor(item)"
                :title="getOverallStatusText(item)"
              >
                {{ getOverallStatusIcon(item) }}
              </v-icon>
            </template>

            <!-- ดำเนินการ -->
            <template v-slot:item.actions="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="openAssessmentDialog(item, 1)">
                    <v-list-item-icon
                      ><v-icon small color="blue"
                        >mdi-clipboard-edit</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title>ประเมินรอบ 1</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openAssessmentDialog(item, 2)">
                    <v-list-item-icon
                      ><v-icon small color="teal"
                        >mdi-clipboard-edit</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title>ประเมินรอบ 2</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="openAttendanceDialog(item)">
                    <v-list-item-icon
                      ><v-icon small color="orange"
                        >mdi-calendar-clock</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title>ข้อมูลการลา</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDisciplineDialog(item)">
                    <v-list-item-icon
                      ><v-icon small color="red"
                        >mdi-gavel</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-title>เพิ่มข้อมูลวินัย</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="openPersonnelDetailDialog(item)">
                    <v-list-item-icon
                      ><v-icon small>mdi-eye</v-icon></v-list-item-icon
                    >
                    <v-list-item-title>ดูข้อมูลรวม</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>

        <!-- ===== Card View ===== -->
        <template v-else>
          <v-row>
            <v-col
              v-for="item in filteredPersonnelData"
              :key="item.id_card"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card
                outlined
                class="rounded-lg pa-0"
                :class="getCardBorderClass(item)"
              >
                <!-- Card Header -->
                <v-card-text class="pb-1 pt-3 px-3">
                  <div class="d-flex align-center mb-2">
                    <v-avatar
                      size="36"
                      :color="
                        item.sex === 'หญิง'
                          ? 'pink lighten-3'
                          : 'blue lighten-3'
                      "
                      class="mr-2"
                    >
                      <span class="white--text font-weight-bold">{{
                        (item.frist_name || "?").charAt(0)
                      }}</span>
                    </v-avatar>
                    <div class="flex-grow-1 min-width-0">
                      <div class="text-body-2 font-weight-bold text-truncate">
                        {{ item.full_name }}
                      </div>
                      <div class="text-caption grey--text text-truncate">
                        {{ item.name_postion }}
                      </div>
                    </div>
                    <v-icon :color="getOverallStatusColor(item)" size="20">{{
                      getOverallStatusIcon(item)
                    }}</v-icon>
                  </div>
                  <v-chip
                    x-small
                    color="primary lighten-5"
                    class="primary--text mb-2"
                    style="max-width:100%"
                  >
                    <span class="text-truncate">{{ item.user_firstname }}</span>
                  </v-chip>
                </v-card-text>
                <v-divider></v-divider>
                <!-- สถานะรอบ -->
                <v-card-text class="pa-2">
                  <div class="d-flex" style="gap:4px">
                    <!-- รอบ 1 -->
                    <div class="flex-1 text-center">
                      <div class="text-caption grey--text mb-1">รอบ 1</div>
                      <v-chip
                        v-if="item.round1"
                        x-small
                        :color="getStatusColor(item.round1.assessment_status)"
                        text-color="white"
                        class="d-block"
                        style="cursor:pointer; width:100%; justify-content:center"
                        @click="openAssessmentDialog(item, 1)"
                      >
                        {{ formatNumber(item.round1.total_score) }}
                      </v-chip>
                      <v-btn
                        v-else
                        x-small
                        block
                        color="red lighten-1"
                        dark
                        @click="openAssessmentDialog(item, 1)"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                    <!-- รอบ 2 -->
                    <div class="flex-1 text-center">
                      <div class="text-caption grey--text mb-1">รอบ 2</div>
                      <v-chip
                        v-if="item.round2"
                        x-small
                        :color="getStatusColor(item.round2.assessment_status)"
                        text-color="white"
                        class="d-block"
                        style="cursor:pointer; width:100%; justify-content:center"
                        @click="openAssessmentDialog(item, 2)"
                      >
                        {{ formatNumber(item.round2.total_score) }}
                      </v-chip>
                      <v-btn
                        v-else
                        x-small
                        block
                        color="red lighten-1"
                        dark
                        @click="openAssessmentDialog(item, 2)"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                    <!-- การลา -->
                    <div class="flex-1 text-center">
                      <div class="text-caption grey--text mb-1">การลา</div>
                      <v-chip
                        v-if="item.attendance"
                        x-small
                        color="green"
                        text-color="white"
                        class="d-block"
                        style="cursor:pointer; width:100%; justify-content:center"
                        @click="openAttendanceDialog(item)"
                      >
                        <v-icon x-small>mdi-check</v-icon>
                      </v-chip>
                      <v-btn
                        v-else
                        x-small
                        block
                        color="orange"
                        dark
                        @click="openAttendanceDialog(item)"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <!-- ===== Legend ===== -->
        <div class="mt-3 d-flex flex-wrap align-center" style="gap:12px">
          <span class="text-caption grey--text">สัญลักษณ์:</span>
          <v-chip x-small color="red lighten-1" text-color="white"
            >ยังไม่รายงาน</v-chip
          >
          <v-chip x-small color="grey" text-color="white">ร่าง</v-chip>
          <v-chip x-small color="blue" text-color="white">ส่งแล้ว</v-chip>
          <v-chip x-small color="green" text-color="white">อนุมัติ</v-chip>
          <v-icon small color="green">mdi-check-circle</v-icon
          ><span class="text-caption">ครบทั้ง 2 รอบ + การลา</span>
          <v-icon small color="orange">mdi-alert-circle</v-icon
          ><span class="text-caption">ครบบางส่วน</span>
          <v-icon small color="red">mdi-close-circle</v-icon
          ><span class="text-caption">ยังไม่มีข้อมูล</span>
        </div>
      </base-material-card>

      <!-- ===== Dialog: กรอก/แก้ไขการประเมิน ===== -->
      <v-dialog v-model="assessmentDialog" max-width="780px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left color="primary">mdi-clipboard-edit</v-icon>
            {{ editingAssessment.id ? "แก้ไข" : "กรอก" }}การประเมิน —
            <strong class="ml-2 primary--text">{{ dialogPersonName }}</strong>
            <v-chip
              small
              class="ml-2"
              :color="dialogRound === 1 ? 'blue' : 'teal'"
              text-color="white"
            >
              รอบที่ {{ dialogRound }}
            </v-chip>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <!-- ข้อมูลพนักงาน (read-only) -->
                <v-col cols="12">
                  <v-card outlined class="pa-3 grey lighten-5">
                    <v-row dense>
                      <v-col cols="12" md="4">
                        <div class="text-caption grey--text">หน่วยงาน</div>
                        <div class="text-body-2 font-weight-medium">
                          {{ editingAssessment._college_name || "-" }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="text-caption grey--text">ตำแหน่ง</div>
                        <div class="text-body-2 font-weight-medium">
                          {{ editingAssessment._name_postion || "-" }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="text-caption grey--text">เลขที่ตำแหน่ง</div>
                        <div class="text-body-2 font-weight-medium">
                          {{ editingAssessment._id_position || "-" }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <!-- ช่วงเวลา -->
                <v-col cols="12">
                  <v-alert dense type="info" text class="mb-0 mt-2">
                    <strong>รอบที่ {{ dialogRound }}:</strong>
                    {{
                      dialogRound === 1
                        ? "1 ต.ค. " +
                          (selectedYear - 1) +
                          " – 31 มี.ค. " +
                          selectedYear
                        : "1 เม.ย. " +
                          selectedYear +
                          " – 30 ก.ย. " +
                          selectedYear
                    }}
                    &nbsp;|&nbsp; เกณฑ์: ดีเด่น ≥95 | ดีมาก ≥85 | ดี ≥75 | พอใช้
                    ≥65 | ต้องปรับปรุง &lt;65
                  </v-alert>
                </v-col>

                <!-- คะแนน -->
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="editingAssessment.performance_score"
                    label="ผลสัมฤทธิ์ (เต็ม 80) *"
                    type="number"
                    step="0.01"
                    min="0"
                    max="80"
                    outlined
                    :rules="[v => (v >= 0 && v <= 80) || 'คะแนน 0-80']"
                    @input="calculateTotalScore"
                  >
                    <template v-slot:append
                      ><span class="text-caption grey--text"
                        >/80</span
                      ></template
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="editingAssessment.competency_score"
                    label="สมรรถนะ/พฤติกรรม (เต็ม 20) *"
                    type="number"
                    step="0.01"
                    min="0"
                    max="20"
                    outlined
                    :rules="[v => (v >= 0 && v <= 20) || 'คะแนน 0-20']"
                    @input="calculateTotalScore"
                  >
                    <template v-slot:append
                      ><span class="text-caption grey--text"
                        >/20</span
                      ></template
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :value="formatNumber(calculatedTotalScore)"
                    label="คะแนนรวม"
                    outlined
                    readonly
                    background-color="grey lighten-4"
                  >
                    <template v-slot:append>
                      <v-chip
                        small
                        :color="getScoreColor(calculatedTotalScore)"
                        text-color="white"
                      >
                        {{ autoGrade }}
                      </v-chip>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="editingAssessment.performance_grade"
                    :items="gradeOptions"
                    label="สรุประดับผลการประเมิน"
                    outlined
                    hint="ระบบเสนออัตโนมัติ สามารถเปลี่ยนได้"
                    persistent-hint
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editingAssessment.assessment_status"
                    :items="assessmentStatusOptions"
                    label="สถานะ"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editingAssessment.performance_note"
                    label="หมายเหตุ"
                    outlined
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <!-- ลบ (เฉพาะตอนแก้ไข) -->
            <v-btn
              v-if="editingAssessment.id"
              text
              color="error"
              @click="deleteAssessment(editingAssessment)"
            >
              <v-icon left small>mdi-delete</v-icon>ลบ
            </v-btn>
            <!-- ไฟล์แนบ -->
            <v-btn
              v-if="editingAssessment.id"
              text
              color="purple"
              @click="openFileDialogFromAssessment(editingAssessment)"
            >
              <v-icon left small>mdi-paperclip</v-icon>ไฟล์แนบ ({{
                editingAssessment.file_count || 0
              }})
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="assessmentDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveAssessment" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog: ข้อมูลการลา ===== -->
      <v-dialog v-model="attendanceDialog" max-width="820px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left color="orange">mdi-calendar-clock</v-icon>
            ข้อมูลการลา/มาสาย/ขาดราชการ —
            <strong class="ml-2 orange--text">{{ dialogPersonName }}</strong>
            <v-chip small class="ml-2" color="orange" text-color="white"
              >ปี {{ selectedYear }}</v-chip
            >
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <!-- ลาป่วย -->
                <v-col cols="12"
                  ><div
                    class="text-subtitle-2 orange--text font-weight-bold mb-n2"
                  >
                    <v-icon small color="orange" class="mr-1"
                      >mdi-hospital</v-icon
                    >ลาป่วย
                  </div></v-col
                >
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.sick_leave_times"
                    label="จำนวนครั้ง"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.sick_leave_days"
                    label="จำนวนวัน"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.sick_leave_workdays"
                    label="วันทำการ"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <!-- ลาคลอด -->
                <v-col cols="12"
                  ><div
                    class="text-subtitle-2 purple--text font-weight-bold mb-n2"
                  >
                    <v-icon small color="purple" class="mr-1">mdi-baby</v-icon
                    >ลาคลอดบุตร
                  </div></v-col
                >
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.maternity_leave_times"
                    label="จำนวนครั้ง"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.maternity_leave_days"
                    label="จำนวนวัน"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.maternity_leave_workdays"
                    label="วันทำการ"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <!-- ลากิจ -->
                <v-col cols="12"
                  ><div
                    class="text-subtitle-2 blue--text font-weight-bold mb-n2"
                  >
                    <v-icon small color="blue" class="mr-1"
                      >mdi-briefcase</v-icon
                    >ลากิจส่วนตัว
                  </div></v-col
                >
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.personal_leave_times"
                    label="จำนวนครั้ง"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.personal_leave_days"
                    label="จำนวนวัน"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.personal_leave_workdays"
                    label="วันทำการ"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <!-- ลาทหาร -->
                <v-col cols="12"
                  ><div
                    class="text-subtitle-2 teal--text font-weight-bold mb-n2"
                  >
                    <v-icon small color="teal" class="mr-1"
                      >mdi-shield-account</v-icon
                    >ลาราชการทหาร
                  </div></v-col
                >
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.military_leave_times"
                    label="จำนวนครั้ง"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.military_leave_days"
                    label="จำนวนวัน"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model.number="editingAttendance.military_leave_workdays"
                    label="วันทำการ"
                    type="number"
                    min="0"
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <!-- มาสาย/ขาด -->
                <v-col cols="12"><v-divider></v-divider></v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingAttendance.late_count"
                    label="มาสาย (ครั้ง)"
                    type="number"
                    min="0"
                    outlined
                    prepend-inner-icon="mdi-clock-alert"
                    color="red"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingAttendance.absent_count"
                    label="ขาดราชการ (วัน)"
                    type="number"
                    min="0"
                    outlined
                    prepend-inner-icon="mdi-account-off"
                    color="deep-orange"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="editingAttendance.id"
              text
              color="error"
              @click="deleteAttendance(editingAttendance)"
            >
              <v-icon left small>mdi-delete</v-icon>ลบ
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="attendanceDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveAttendance" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog: เพิ่มวินัย ===== -->
      <v-dialog v-model="disciplineDialog" max-width="700px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left color="red">mdi-gavel</v-icon>
            เพิ่มข้อมูลการลงโทษทางวินัย —
            <strong class="ml-2 red--text">{{ dialogPersonName }}</strong>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editingDiscipline.discipline_type"
                    :items="disciplineTypes"
                    label="ประเภทการลงโทษ *"
                    outlined
                    :rules="[v => !!v || 'กรุณาเลือก']"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate(editingDiscipline.discipline_date)"
                        label="วันที่ถูกลงโทษ *"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editingDiscipline.discipline_date"
                      @input="dateMenu = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editingDiscipline.discipline_reason"
                    label="เหตุผลการลงโทษ *"
                    outlined
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="editingDiscipline.court_case"
                    :true-value="1"
                    :false-value="0"
                    label="มีคดีอาญา"
                    color="red"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6" v-if="editingDiscipline.court_case">
                  <v-textarea
                    v-model="editingDiscipline.court_detail"
                    label="รายละเอียดคดีอาญา"
                    outlined
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="disciplineDialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" @click="saveDiscipline" :loading="saving">
              <v-icon left>mdi-content-save</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog: รายการวินัยของบุคคล ===== -->
      <v-dialog v-model="disciplineListDialog" max-width="700px">
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left color="red">mdi-gavel</v-icon>
            รายการวินัย — {{ dialogPersonName }}
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(d, i) in dialogDisciplineList"
                :key="i"
                class="px-0"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-chip
                      x-small
                      :color="getDisciplineTypeColor(d.discipline_type)"
                      text-color="white"
                      class="mr-2"
                      >{{ d.discipline_type }}</v-chip
                    >
                    {{ formatDate(d.discipline_date) }}
                    <v-chip
                      x-small
                      color="red"
                      text-color="white"
                      class="ml-1"
                      v-if="d.court_case"
                      >คดีอาญา</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    d.discipline_reason
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="deleteDisciplineById(d)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" @click="openDisciplineDialogFromList()">
              <v-icon left small>mdi-plus</v-icon>เพิ่มรายการใหม่
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="disciplineListDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog: ไฟล์แนบ ===== -->
      <v-dialog v-model="fileDialog" max-width="800px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-4">
            <v-icon left>mdi-paperclip</v-icon>
            ไฟล์แนบ —
            {{
              selectedAssessmentForFile
                ? selectedAssessmentForFile._full_name
                : ""
            }}
            (รอบที่
            {{
              selectedAssessmentForFile
                ? selectedAssessmentForFile.assessment_round
                : ""
            }})
          </v-card-title>
          <v-card-text class="pt-4">
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="uploadFileCategory"
                  :items="fileCategoryOptions"
                  label="ประเภทเอกสาร *"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="uploadFileDescription"
                  label="คำอธิบาย"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input
                  v-model="uploadFile"
                  label="เลือกไฟล์"
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  outlined
                  dense
                  show-size
                  prepend-icon="mdi-file"
                ></v-file-input>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  small
                  @click="uploadAssessmentFile"
                  :loading="uploading"
                  :disabled="!uploadFile || !uploadFileCategory"
                >
                  <v-icon left>mdi-upload</v-icon>อัปโหลด
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="fileHeaders"
              :items="assessmentFiles"
              :loading="loadingFiles"
              class="elevation-1 mt-2"
              dense
            >
              <template v-slot:item.file_category="{ item }">
                <v-chip
                  x-small
                  :color="getFileCategoryColor(item.file_category)"
                  text-color="white"
                  >{{ getFileCategoryLabel(item.file_category) }}</v-chip
                >
              </template>
              <template v-slot:item.file_size="{ item }">{{
                formatFileSize(item.file_size)
              }}</template>
              <template v-slot:item.created_at="{ item }">{{
                formatDateTime(item.created_at)
              }}</template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon x-small color="info" @click="downloadFile(item)"
                  ><v-icon>mdi-download</v-icon></v-btn
                >
                <v-btn icon x-small color="error" @click="deleteFile(item)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="fileDialog = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
        top
      >
        <v-icon left>{{ snackbar.icon }}</v-icon
        >{{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Manpowermenubar_govem from "../../../components/admin/manpowermenubar_govem.vue";
import * as XLSX from "xlsx";

export default {
  name: "AssessmentGovemCentral",
  components: { Manpowermenubar_govem },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      saving: false,
      uploading: false,
      loadingFiles: false,

      selectedYear: new Date().getFullYear() + 543,
      selectedCollegeCode: null,
      statusFilter: null,
      searchText: "",
      viewMode: "list",
      dateMenu: false,

      user: {},
      // ===== แหล่งข้อมูลหลัก =====
      personnelList: [], // พนักงานทั้งหมดส่วนกลาง (user_status V)
      assessmentData: [], // ข้อมูลประเมินทุกรอบ
      attendanceData: [], // ข้อมูลการลา
      disciplineData: [], // ข้อมูลวินัย

      // Dialog state
      assessmentDialog: false,
      attendanceDialog: false,
      disciplineDialog: false,
      disciplineListDialog: false,
      fileDialog: false,

      dialogPersonName: "",
      dialogPersonItem: null, // item ใน mergedPersonnelData ที่กำลังแก้ไข
      dialogRound: 1,
      dialogDisciplineList: [],

      editingAssessment: {},
      editingAttendance: {},
      editingDiscipline: {},

      selectedAssessmentForFile: null,
      assessmentFiles: [],
      uploadFile: null,
      uploadFileCategory: "pf_pnr_1_1",
      uploadFileDescription: "",

      years: [],

      // Options
      gradeOptions: ["ดีเด่น", "ดีมาก", "ดี", "พอใช้", "ต้องปรับปรุง"],
      disciplineTypes: [
        "ตักเตือน",
        "ภาคทัณฑ์",
        "ตัดเงินเดือน",
        "ลดเงินเดือน",
        "ปลดออก",
        "ไล่ออก",
        "อื่นๆ"
      ],
      assessmentStatusOptions: [
        { text: "ร่าง", value: "draft" },
        { text: "ส่งแล้ว", value: "submitted" },
        { text: "อนุมัติ", value: "approved" },
        { text: "ส่งกลับ", value: "rejected" }
      ],
      statusFilterOptions: [
        { text: "ยังไม่ครบทั้ง 2 รอบ", value: "incomplete" },
        { text: "รอบ 1 ยังไม่รายงาน", value: "missing_round1" },
        { text: "รอบ 2 ยังไม่รายงาน", value: "missing_round2" },
        { text: "ยังไม่มีข้อมูลการลา", value: "missing_attendance" },
        { text: "ครบทุกรายการ", value: "complete" }
      ],
      fileCategoryOptions: [
        { text: "ปผ.พนร. 1-1", value: "pf_pnr_1_1" },
        { text: "ปผ.พนร. 1-2", value: "pf_pnr_1_2" },
        { text: "ปผ.พนร. 1-3", value: "pf_pnr_1_3" },
        { text: "ปผ.พนร. 1-4", value: "pf_pnr_1_4" },
        { text: "เอกสารประกอบ", value: "supporting_doc" },
        { text: "อื่นๆ", value: "other" }
      ],

      // Table headers
      personnelHeaders: [
        { text: "#", value: "seq", width: "50px", sortable: false },
        { text: "หน่วยงาน", value: "user_firstname", width: "150px" },
        { text: "ชื่อ-สกุล / ตำแหน่ง", value: "full_name", width: "200px" },
        {
          text: "ประเมินรอบ 1",
          value: "round1_status",
          width: "160px",
          align: "center",
          sortable: false
        },
        {
          text: "ประเมินรอบ 2",
          value: "round2_status",
          width: "160px",
          align: "center",
          sortable: false
        },
        {
          text: "ข้อมูลการลา",
          value: "attendance_status",
          width: "130px",
          align: "center",
          sortable: false
        },
        {
          text: "วินัย",
          value: "discipline_status",
          width: "110px",
          align: "center",
          sortable: false
        },
        {
          text: "สถานะรวม",
          value: "overall_status",
          width: "90px",
          align: "center",
          sortable: false
        },
        {
          text: "",
          value: "actions",
          width: "50px",
          align: "center",
          sortable: false
        }
      ],
      fileHeaders: [
        { text: "ประเภท", value: "file_category", width: "140px" },
        { text: "ชื่อไฟล์", value: "file_name" },
        { text: "ขนาด", value: "file_size", width: "80px" },
        { text: "ผู้อัปโหลด", value: "uploaded_by_name", width: "120px" },
        { text: "วันที่", value: "created_at", width: "140px" },
        { text: "", value: "actions", width: "80px", sortable: false }
      ],

      snackbar: { show: false, color: "success", icon: "mdi-check", text: "" }
    };
  },

  computed: {
    // ===== รายชื่อหน่วยงานทั้งหมด =====
    collegeList() {
      const map = {};
      this.personnelList.forEach(p => {
        if (p.user_code && !map[p.user_code]) {
          map[p.user_code] = {
            code: p.user_code,
            name: p.user_firstname || p.user_code
          };
        }
      });
      return Object.values(map).sort((a, b) =>
        a.name.localeCompare(b.name, "th")
      );
    },
    collegeFilterOptions() {
      return this.collegeList.map(c => ({ text: c.name, value: c.code }));
    },

    // ===== Merge พนักงาน + ข้อมูลประเมิน + ลา + วินัย =====
    mergedPersonnelData() {
      // index assessment ตาม id_card + round
      const assMap = {};
      this.assessmentData.forEach(a => {
        const key = `${a.id_card}_${a.assessment_round}`;
        assMap[key] = a;
      });
      // index attendance ตาม id_card
      const attMap = {};
      this.attendanceData.forEach(a => {
        attMap[a.id_card] = a;
      });
      // index disciplines ตาม id_card (อาจมีหลายรายการ)
      const discMap = {};
      this.disciplineData.forEach(d => {
        if (!discMap[d.id_card]) discMap[d.id_card] = [];
        discMap[d.id_card].push(d);
      });

      return this.personnelList.map(p => ({
        ...p,
        round1: assMap[`${p.id_card}_1`] || null,
        round2: assMap[`${p.id_card}_2`] || null,
        attendance: attMap[p.id_card] || null,
        disciplines: discMap[p.id_card] || []
      }));
    },

    // ===== กรองตาม college + status + search =====
    filteredPersonnelData() {
      let list = this.mergedPersonnelData;

      if (this.selectedCollegeCode) {
        list = list.filter(p => p.user_code === this.selectedCollegeCode);
      }
      if (this.statusFilter) {
        list = list.filter(p => {
          switch (this.statusFilter) {
            case "incomplete":
              return !p.round1 || !p.round2;
            case "missing_round1":
              return !p.round1;
            case "missing_round2":
              return !p.round2;
            case "missing_attendance":
              return !p.attendance;
            case "complete":
              return p.round1 && p.round2 && p.attendance;
            default:
              return true;
          }
        });
      }
      if (this.searchText) {
        const q = this.searchText.toLowerCase();
        list = list.filter(
          p =>
            p.full_name.toLowerCase().includes(q) ||
            (p.user_firstname || "").toLowerCase().includes(q) ||
            (p.name_postion || "").toLowerCase().includes(q)
        );
      }
      return list;
    },

    // ===== สถิติสรุป =====
    summaryStats() {
      const list = this.mergedPersonnelData;
      const filtered = this.selectedCollegeCode
        ? list.filter(p => p.user_code === this.selectedCollegeCode)
        : list;

      return {
        total: filtered.length,
        submitted_round1: filtered.filter(p => p.round1).length,
        submitted_round2: filtered.filter(p => p.round2).length,
        has_attendance: filtered.filter(p => p.attendance).length,
        missing_round1: filtered.filter(p => !p.round1).length,
        missing_round2: filtered.filter(p => !p.round2).length,
        discipline_cases: filtered.reduce(
          (s, p) => s + (p.disciplines ? p.disciplines.length : 0),
          0
        ),
        complete: filtered.filter(p => p.round1 && p.round2 && p.attendance)
          .length
      };
    },
    summaryCards() {
      const s = this.summaryStats;
      return [
        {
          label: "พนักงานทั้งหมด",
          value: s.total,
          color: "blue",
          icon: "mdi-account-multiple"
        },
        {
          label: "ครบทั้ง 2 รอบ+ลา",
          value: s.complete,
          color: "green",
          icon: "mdi-check-circle"
        },
        {
          label: "ประเมินรอบ 1",
          value: s.submitted_round1,
          color: "blue",
          icon: "mdi-numeric-1-circle"
        },
        {
          label: "ประเมินรอบ 2",
          value: s.submitted_round2,
          color: "teal",
          icon: "mdi-numeric-2-circle"
        },
        {
          label: "ยังไม่ครบรอบ 1",
          value: s.missing_round1,
          color: "red",
          icon: "mdi-alert-circle"
        },
        {
          label: "ยังไม่ครบรอบ 2",
          value: s.missing_round2,
          color: "orange",
          icon: "mdi-alert-circle-outline"
        }
      ];
    },
    round1Progress() {
      if (!this.summaryStats.total) return 0;
      return Math.round(
        (this.summaryStats.submitted_round1 / this.summaryStats.total) * 100
      );
    },
    round2Progress() {
      if (!this.summaryStats.total) return 0;
      return Math.round(
        (this.summaryStats.submitted_round2 / this.summaryStats.total) * 100
      );
    },

    calculatedTotalScore() {
      return (
        (parseFloat(this.editingAssessment.performance_score) || 0) +
        (parseFloat(this.editingAssessment.competency_score) || 0)
      );
    },
    autoGrade() {
      return this.getGradeFromScore(this.calculatedTotalScore);
    }
  },

  async mounted() {
    await this.initializeComponent();
  },

  methods: {
    // ===== Init =====
    async initializeComponent() {    
      try {
        const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        const res = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: userSession.user_ID
        });
        this.user = res.data;
        this.generateYears();
        await this.loadPersonnelList();
        await this.loadAllData();
      } catch {
        this.showSnackbar(
          "เกิดข้อผิดพลาดในการโหลดข้อมูล",
          "error",
          "mdi-alert"
        );
      } finally {
      }
    },
    generateYears() {
      const cur = new Date().getFullYear() + 543;
      this.years = Array.from({ length: 5 }, (_, i) => cur - i);
    },

    // ===== โหลดพนักงานส่วนกลาง =====
    async loadPersonnelList() {
      try {
        const res = await this.$http.post("government_employee_news.php", {
          ApiKey: this.ApiKey,
          user_status: "V"
        });
        const raw = res.data.data || (Array.isArray(res.data) ? res.data : []);
        this.personnelList = raw
          .filter(p => p.id_card && p.id_card !== "0" && p.id_card !== 0)
          .map(p => ({
            ...p,
            full_name: `${p.title_s || ""}${p.frist_name} ${p.last_name}`.trim()
          }));
      } catch {
        this.showSnackbar(
          "ไม่สามารถโหลดรายชื่อพนักงานได้",
          "error",
          "mdi-alert"
        );
      }
    },

    // ===== โหลดข้อมูลประเมิน/ลา/วินัย (ไม่ระบุ college_code = ทั้งหมด) =====
    async loadAllData() { 
      try {
        await Promise.all([
          this.loadAssessmentData(),
          this.loadAttendanceData(),
          this.loadDisciplineData()
        ]);
      } catch {
        this.showSnackbar(
          "เกิดข้อผิดพลาดในการโหลดข้อมูล",
          "error",
          "mdi-alert"
        );
      } finally {
      }
    },
    async loadAssessmentData() {
      try {
        const res = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "get",
          assessment_year: this.selectedYear,
          user_status: "V"
        });
        this.assessmentData = Array.isArray(res.data) ? res.data : [];
      } catch {
        this.assessmentData = [];
      }
    },
    async loadAttendanceData() {
      try {
        const res = await this.$http.post("gov_em_attendance.php", {
          ApiKey: this.ApiKey,
          action: "get",
          attendance_year: this.selectedYear,
          user_status: "V"
        });
        this.attendanceData = Array.isArray(res.data) ? res.data : [];
      } catch {
        this.attendanceData = [];
      }
    },
    async loadDisciplineData() {
      try {
        const res = await this.$http.post("gov_em_discipline.php", {
          ApiKey: this.ApiKey,
          action: "get",
          discipline_year: this.selectedYear,
          user_status: "V"
        });
        this.disciplineData = Array.isArray(res.data) ? res.data : [];
      } catch {
        this.disciplineData = [];
      }
    },

    // ===== Dialog: การประเมิน (เปิดจาก personnel row) =====
    openAssessmentDialog(personnelItem, round) {
      this.dialogPersonItem = personnelItem;
      this.dialogPersonName = personnelItem.full_name;
      this.dialogRound = round;

      const existing =
        round === 1 ? personnelItem.round1 : personnelItem.round2;
      if (existing) {
        this.editingAssessment = {
          ...existing,
          _college_name: personnelItem.user_firstname,
          _name_postion: personnelItem.name_postion,
          _id_position: personnelItem.id_position,
          _full_name: personnelItem.full_name
        };
      } else {
        this.editingAssessment = {
          id: null,
          id_card: personnelItem.id_card,
          assessment_round: round,
          performance_score: 0,
          competency_score: 0,
          performance_grade: "",
          performance_note: "",
          assessment_status: "draft",
          assessment_date: new Date().toISOString().substr(0, 10),
          _college_name: personnelItem.user_firstname,
          _name_postion: personnelItem.name_postion,
          _id_position: personnelItem.id_position,
          _full_name: personnelItem.full_name
        };
      }
      this.assessmentDialog = true;
    },

    async saveAssessment() {
      if (this.editingAssessment.performance_score > 80) {
        this.showSnackbar("คะแนนผลสัมฤทธิ์ไม่เกิน 80", "warning", "mdi-alert");
        return;
      }
      if (this.editingAssessment.competency_score > 20) {
        this.showSnackbar("คะแนนสมรรถนะไม่เกิน 20", "warning", "mdi-alert");
        return;
      }
      this.saving = true;
      try {
        const person = this.dialogPersonItem;
        const action = this.editingAssessment.id ? "update" : "insert";
        const payload = {
          ApiKey: this.ApiKey,
          action,
          id_card: this.editingAssessment.id_card,
          id: this.editingAssessment.id,
          assessment_round: this.dialogRound,
          performance_score: this.editingAssessment.performance_score,
          competency_score: this.editingAssessment.competency_score,
          total_score: this.calculatedTotalScore,
          performance_grade:
            this.editingAssessment.performance_grade || this.autoGrade,
          performance_note: this.editingAssessment.performance_note,
          assessment_status:
            this.editingAssessment.assessment_status || "draft",
          assessment_date: this.editingAssessment.assessment_date,
          assessment_year: this.selectedYear,
          college_code: person ? person.user_code : null,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || ""
        };
        const res = await this.$http.post("gov_em_assessment.php", payload);
        if (res.data.status) {
          this.showSnackbar(
            "บันทึกการประเมินเรียบร้อย",
            "success",
            "mdi-check"
          );
          this.assessmentDialog = false;
          await this.loadAssessmentData();
        } else {
          this.showSnackbar(
            res.data.message || "เกิดข้อผิดพลาด",
            "error",
            "mdi-alert"
          );
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteAssessment(item) {
      if (
        !confirm(
          `ลบการประเมินรอบ ${this.dialogRound} ของ ${this.dialogPersonName}?`
        )
      )
        return;
      try {
        const res = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "delete",
          id: item.id,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || ""
        });
        if (res.data.status) {
          this.showSnackbar("ลบเรียบร้อย", "success", "mdi-check");
          this.assessmentDialog = false;
          await this.loadAssessmentData();
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },

    // ===== Dialog: การลา (เปิดจาก personnel row) =====
    openAttendanceDialog(personnelItem) {
      this.dialogPersonItem = personnelItem;
      this.dialogPersonName = personnelItem.full_name;
      if (personnelItem.attendance) {
        this.editingAttendance = { ...personnelItem.attendance };
      } else {
        this.editingAttendance = {
          id: null,
          id_card: personnelItem.id_card,
          sick_leave_times: 0,
          sick_leave_days: 0,
          sick_leave_workdays: 0,
          maternity_leave_times: 0,
          maternity_leave_days: 0,
          maternity_leave_workdays: 0,
          personal_leave_times: 0,
          personal_leave_days: 0,
          personal_leave_workdays: 0,
          military_leave_times: 0,
          military_leave_days: 0,
          military_leave_workdays: 0,
          late_count: 0,
          absent_count: 0
        };
      }
      this.attendanceDialog = true;
    },

    async saveAttendance() {
      if (!this.editingAttendance.id_card) {
        this.showSnackbar("ไม่พบข้อมูลพนักงาน", "warning", "mdi-alert");
        return;
      }
      this.saving = true;
      try {
        const person = this.dialogPersonItem;
        const action = this.editingAttendance.id ? "update" : "insert";
        const res = await this.$http.post("gov_em_attendance.php", {
          ApiKey: this.ApiKey,
          action,
          ...this.editingAttendance,
          attendance_year: this.selectedYear,
          college_code: person ? person.user_code : null
        });
        if (res.data.status) {
          this.showSnackbar(
            "บันทึกข้อมูลการลาเรียบร้อย",
            "success",
            "mdi-check"
          );
          this.attendanceDialog = false;
          await this.loadAttendanceData();
        } else {
          this.showSnackbar(
            res.data.message || "เกิดข้อผิดพลาด",
            "error",
            "mdi-alert"
          );
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteAttendance(item) {
      if (!confirm(`ลบข้อมูลการลาของ ${this.dialogPersonName}?`)) return;
      try {
        const res = await this.$http.post("gov_em_attendance.php", {
          ApiKey: this.ApiKey,
          action: "delete",
          id: item.id
        });
        if (res.data.status) {
          this.showSnackbar("ลบเรียบร้อย", "success", "mdi-check");
          this.attendanceDialog = false;
          await this.loadAttendanceData();
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },

    // ===== Dialog: วินัย =====
    openDisciplineDialog(personnelItem) {
      this.dialogPersonItem = personnelItem;
      this.dialogPersonName = personnelItem.full_name;
      this.editingDiscipline = {
        id: null,
        id_card: personnelItem.id_card,
        discipline_type: "",
        discipline_reason: "",
        discipline_date: new Date().toISOString().substr(0, 10),
        court_case: 0,
        court_detail: ""
      };
      this.disciplineDialog = true;
    },
    openDisciplineListDialog(personnelItem) {
      this.dialogPersonItem = personnelItem;
      this.dialogPersonName = personnelItem.full_name;
      this.dialogDisciplineList = personnelItem.disciplines || [];
      this.disciplineListDialog = true;
    },
    openDisciplineDialogFromList() {
      this.disciplineListDialog = false;
      this.openDisciplineDialog(this.dialogPersonItem);
    },

    async saveDiscipline() {
      if (
        !this.editingDiscipline.discipline_type ||
        !this.editingDiscipline.discipline_reason
      ) {
        this.showSnackbar("กรุณากรอกข้อมูลให้ครบ", "warning", "mdi-alert");
        return;
      }
      this.saving = true;
      try {
        const person = this.dialogPersonItem;
        const res = await this.$http.post("gov_em_discipline.php", {
          ApiKey: this.ApiKey,
          action: "insert",
          ...this.editingDiscipline,
          discipline_year: this.selectedYear,
          college_code: person ? person.user_code : null
        });
        if (res.data.status) {
          this.showSnackbar(
            "บันทึกข้อมูลวินัยเรียบร้อย",
            "success",
            "mdi-check"
          );
          this.disciplineDialog = false;
          await this.loadDisciplineData();
        } else {
          this.showSnackbar(
            res.data.message || "เกิดข้อผิดพลาด",
            "error",
            "mdi-alert"
          );
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      } finally {
        this.saving = false;
      }
    },

    async deleteDisciplineById(d) {
      if (
        !confirm(
          `ลบรายการวินัย "${d.discipline_type}" ของ ${this.dialogPersonName}?`
        )
      )
        return;
      try {
        const res = await this.$http.post("gov_em_discipline.php", {
          ApiKey: this.ApiKey,
          action: "delete",
          id: d.id
        });
        if (res.data.status) {
          this.showSnackbar("ลบเรียบร้อย", "success", "mdi-check");
          await this.loadDisciplineData();
          // อัปเดต list ใน dialog ด้วย
          this.dialogDisciplineList = this.dialogDisciplineList.filter(
            x => x.id !== d.id
          );
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },

    // ===== ไฟล์แนบ =====
    openFileDialogFromAssessment(assessmentItem) {
      this.selectedAssessmentForFile = assessmentItem;
      this.fileDialog = true;
      this.uploadFile = null;
      this.uploadFileCategory = "pf_pnr_1_1";
      this.uploadFileDescription = "";
      this.loadAssessmentFiles(assessmentItem.id);
    },
    async loadAssessmentFiles(assessmentId) {
      this.loadingFiles = true;
      try {
        const res = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "get_files",
          assessment_id: assessmentId
        });
        this.assessmentFiles = res.data || [];
      } catch {
        this.assessmentFiles = [];
      } finally {
        this.loadingFiles = false;
      }
    },
    async uploadAssessmentFile() {
      if (!this.uploadFile || !this.selectedAssessmentForFile) return;
      this.uploading = true;
      try {
        const fd = new FormData();
        fd.append("ApiKey", this.ApiKey);
        fd.append("action", "upload_file");
        fd.append("assessment_id", this.selectedAssessmentForFile.id);
        fd.append("file_category", this.uploadFileCategory);
        fd.append("file_description", this.uploadFileDescription);
        fd.append("action_by", this.user.id_card || this.user.user_ID);
        fd.append("action_by_name", this.user.user_firstname || "");
        fd.append("assessment_file", this.uploadFile);
        const res = await this.$http.post("gov_em_assessment.php", fd, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (res.data.status) {
          this.showSnackbar("อัปโหลดเรียบร้อย", "success", "mdi-check");
          this.uploadFile = null;
          await this.loadAssessmentFiles(this.selectedAssessmentForFile.id);
          await this.loadAssessmentData();
        } else {
          this.showSnackbar(
            res.data.message || "อัปโหลดล้มเหลว",
            "error",
            "mdi-alert"
          );
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      } finally {
        this.uploading = false;
      }
    },
    async deleteFile(file) {
      if (!confirm(`ลบไฟล์ "${file.file_name}"?`)) return;
      try {
        const res = await this.$http.post("gov_em_assessment.php", {
          ApiKey: this.ApiKey,
          action: "delete_file",
          file_id: file.id,
          action_by: this.user.id_card || this.user.user_ID,
          action_by_name: this.user.user_firstname || ""
        });
        if (res.data.status) {
          this.showSnackbar("ลบไฟล์เรียบร้อย", "success", "mdi-check");
          await this.loadAssessmentFiles(this.selectedAssessmentForFile.id);
          await this.loadAssessmentData();
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      }
    },
    downloadFile(file) {
      window.open("/HRvec_api/" + file.file_path, "_blank");
    },

    // ===== รายงานสรุป =====
    async generateReport() {
      this.loading = true;
      try {
        const res = await this.$http.post("gov_em_assessment_report.php", {
          ApiKey: this.ApiKey,
          action: "generate_report",
          report_year: this.selectedYear,
          user_status: "V",
          ...(this.selectedCollegeCode
            ? { college_code: this.selectedCollegeCode }
            : {})
        });
        if (res.data.status) {
          this.showSnackbar("สร้างรายงานสรุปเรียบร้อย", "success", "mdi-check");
        }
      } catch {
        this.showSnackbar("เกิดข้อผิดพลาด", "error", "mdi-alert");
      } finally {
        this.loading = false;
      }
    },

    // ===== Export Excel =====
    exportToExcel() {
      const wb = XLSX.utils.book_new();
      const ys = String(this.selectedYear).slice(-2);
      const scopeLabel = this.selectedCollegeCode
        ? this.collegeList.find(c => c.code === this.selectedCollegeCode)
            .name || this.selectedCollegeCode
        : "พนักงานราชการส่วนกลางทั้งหมด";

      const headers = [
        [
          `แบบรายงานผลการประเมินการปฏิบัติงาน ปี ${this.selectedYear} — ${scopeLabel}`
        ],
        [
          `จัดทำวันที่ ${this.formatDate(
            new Date().toISOString().substr(0, 10)
          )}`
        ],
        [],
        [
          "ลำดับ",
          "หน่วยงาน",
          "ชื่อ-สกุล",
          "เลขที่ตำแหน่ง",
          "ตำแหน่ง",
          "เงินเดือน",
          `ผลสัมฤทธิ์รอบ1`,
          `สมรรถนะรอบ1`,
          `คะแนนรอบ1`,
          `ระดับรอบ1`,
          `สถานะรอบ1`,
          `ผลสัมฤทธิ์รอบ2`,
          `สมรรถนะรอบ2`,
          `คะแนนรอบ2`,
          `ระดับรอบ2`,
          `สถานะรอบ2`,
          "ลาป่วย(วัน)",
          "ลากิจ(วัน)",
          "ลาคลอด(วัน)",
          "ลาทหาร(วัน)",
          "มาสาย(ครั้ง)",
          "ขาดราชการ(วัน)",
          "วินัย"
        ]
      ];

      const rows = this.filteredPersonnelData.map((p, i) => {
        const r1 = p.round1,
          r2 = p.round2,
          att = p.attendance || {};
        const discText =
          p.disciplines && p.disciplines.length > 0
            ? p.disciplines.map(d => d.discipline_type).join(", ")
            : "ไม่มี";
        return [
          i + 1,
          p.user_firstname || p.user_code || "",
          p.full_name,
          p.id_position || "",
          p.name_postion || "",
          p.salary_s || "",
          r1 ? r1.performance_score : "ยังไม่รายงาน",
          r1 ? r1.competency_score : "-",
          r1 ? r1.total_score : "-",
          r1 ? r1.performance_grade : "-",
          r1 ? this.getStatusLabel(r1.assessment_status) : "-",
          r2 ? r2.performance_score : "ยังไม่รายงาน",
          r2 ? r2.competency_score : "-",
          r2 ? r2.total_score : "-",
          r2 ? r2.performance_grade : "-",
          r2 ? this.getStatusLabel(r2.assessment_status) : "-",
          att.sick_leave_days || 0,
          att.personal_leave_days || 0,
          att.maternity_leave_days || 0,
          att.military_leave_days || 0,
          att.late_count || 0,
          att.absent_count || 0,
          discText
        ];
      });

      const ws = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      ws["!cols"] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 24 },
        { wch: 12 },
        { wch: 20 },
        { wch: 10 },
        { wch: 12 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 12 },
        { wch: 20 }
      ];
      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 22 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 22 } }
      ];
      XLSX.utils.book_append_sheet(wb, ws, "ปผ.พนร. ส่วนกลาง");
      XLSX.writeFile(wb, `ปผ_พนร_ส่วนกลาง_${this.selectedYear}.xlsx`);
      this.showSnackbar("ส่งออก Excel เรียบร้อย", "success", "mdi-download");
    },

    // ===== สถานะรวมของแต่ละบุคคล =====
    getOverallStatusColor(item) {
      if (item.round1 && item.round2 && item.attendance) return "green";
      if (item.round1 || item.round2 || item.attendance) return "orange";
      return "red";
    },
    getOverallStatusIcon(item) {
      if (item.round1 && item.round2 && item.attendance)
        return "mdi-check-circle";
      if (item.round1 || item.round2 || item.attendance)
        return "mdi-alert-circle";
      return "mdi-close-circle";
    },
    getOverallStatusText(item) {
      const parts = [];
      if (!item.round1) parts.push("ขาดรอบ 1");
      if (!item.round2) parts.push("ขาดรอบ 2");
      if (!item.attendance) parts.push("ขาดข้อมูลการลา");
      return parts.length === 0 ? "ครบถ้วน" : parts.join(", ");
    },
    getCardBorderClass(item) {
      if (item.round1 && item.round2 && item.attendance) return "border-green";
      if (item.round1 || item.round2 || item.attendance) return "border-orange";
      return "border-red";
    },

    // ===== Helpers =====
    calculateTotalScore() {
      this.editingAssessment.performance_grade = this.autoGrade;
    },
    getGradeFromScore(s) {
      if (s >= 95) return "ดีเด่น";
      if (s >= 85) return "ดีมาก";
      if (s >= 75) return "ดี";
      if (s >= 65) return "พอใช้";
      return "ต้องปรับปรุง";
    },
    getScoreColor(s) {
      if (s >= 95) return "green";
      if (s >= 85) return "blue";
      if (s >= 75) return "teal";
      if (s >= 65) return "orange";
      return "red";
    },
    getStatusColor(status) {
      return (
        {
          draft: "grey",
          submitted: "blue",
          approved: "green",
          rejected: "red"
        }[status] || "grey"
      );
    },
    getStatusLabel(status) {
      return (
        {
          draft: "ร่าง",
          submitted: "ส่งแล้ว",
          approved: "อนุมัติ",
          rejected: "ส่งกลับ"
        }[status] ||
        status ||
        "ร่าง"
      );
    },
    getDisciplineTypeColor(type) {
      const m = {
        ตักเตือน: "yellow darken-2",
        ภาคทัณฑ์: "orange",
        ตัดเงินเดือน: "deep-orange",
        ลดเงินเดือน: "red",
        ปลดออก: "red darken-2",
        ไล่ออก: "red darken-4"
      };
      return m[type] || "grey";
    },
    getFileCategoryColor(cat) {
      return (
        {
          pf_pnr_1_1: "blue",
          pf_pnr_1_2: "teal",
          pf_pnr_1_3: "purple",
          pf_pnr_1_4: "indigo",
          supporting_doc: "orange",
          other: "grey"
        }[cat] || "grey"
      );
    },
    getFileCategoryLabel(cat) {
      return (
        {
          pf_pnr_1_1: "ปผ.พนร. 1-1",
          pf_pnr_1_2: "ปผ.พนร. 1-2",
          pf_pnr_1_3: "ปผ.พนร. 1-3",
          pf_pnr_1_4: "ปผ.พนร. 1-4",
          supporting_doc: "เอกสารประกอบ",
          other: "อื่นๆ"
        }[cat] || cat
      );
    },
    formatNumber(v) {
      if (isNaN(v) || v == null) return "0.00";
      return Number(v).toFixed(2);
    },
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleDateString("th-TH");
    },
    formatDateTime(dt) {
      if (!dt) return "";
      return new Date(dt).toLocaleString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 B";
      const k = 1024,
        sizes = ["B", "KB", "MB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
    },
    showSnackbar(text, color = "success", icon = "mdi-check") {
      this.snackbar = { show: true, text, color, icon };
    }
  }
};
</script>

<style scoped>
.personnel-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
.flex-1 {
  flex: 1;
}
.min-width-0 {
  min-width: 0;
}
.border-green {
  border-left: 4px solid #4caf50 !important;
}
.border-orange {
  border-left: 4px solid #ff9800 !important;
}
.border-red {
  border-left: 4px solid #f44336 !important;
}
</style>
